/* eslint-disable default-case */
<template>
  <div>
    <v-overlay :value="dialog">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>
    <div
      class="vertical-layout vertical-menu-modern 1-column  navbar-floating footer-static bg-full-screen-image  blank-page blank-page"
      data-open="click"
      data-menu="vertical-menu-modern"
      data-col="1-column"
    >
      <div class="col-xl-8 col-10 d-flex justify-content-center">
        <div class="card bg-authentication rounded-0 mb-0">
          <div class="row m-0">
            <div class="col-lg-6 d-lg-block d-none text-center align-self-center pl-0 pr-3 py-0">
              <img src="../../../../assets/images/register.jpg" alt="branding logo" />
            </div>
            <div class="col-lg-6 col-12 p-0">
              <div class="card rounded-0 mb-0 p-2">
                <div class="card-header pt-50 pb-1">
                  <div class="card-title">
                    <h4 class="mb-0">Create Account</h4>
                  </div>
                </div>
                <p class="px-2">Fill the below form to create a new account.</p>
                <div class="card-content">
                  <div class="card-body pt-0">
                    <form action="" method="">
                      <div class="form-label-group">
                        <input
                          type="text"
                          id="email"
                          name="email"
                          class="form-control"
                          placeholder="Email"
                          autocomplete="email"
                          :value="fields.email.value"
                          @input="_updateFieldValue('email', $event.target.value)"
                          @blur="_markAsDirty('email')"
                        />
                        <label for="email">Email</label>
                      </div>
                      <p class="inputError">
                        {{
                          fields.email.isDirty && !fields.email.isValid
                            ? "Please enter a valid email"
                            : ""
                        }}
                      </p>
                      <div class="form-label-group">
                        <input
                          type="password"
                          id="inputPassword"
                          class="form-control"
                          placeholder="Password"
                          autocomplete="password"
                          :value="fields.password.value"
                          @input="_updateFieldValue('password', $event.target.value)"
                          @blur="_markAsDirty('password')"
                        />
                        <label for="inputPassword">Password</label>
                      </div>
                      <p class="inputError">
                        {{
                          fields.password.isDirty && !fields.password.isValid
                            ? fields.password.errorText
                            : ""
                        }}
                      </p>
                      <div class="form-label-group">
                        <input
                          type="password"
                          id="inputConfPassword"
                          class="form-control"
                          placeholder="Re-enter your Password"
                          :value="fields.confirmPassword.value"
                          @input="_updateFieldValue('confirmPassword', $event.target.value)"
                          @blur="_markAsDirty('confirmPassword')"
                        />
                        <label for="inputConfPassword">Confirm Password</label>
                      </div>
                      <p class="inputError">
                        {{
                          fields.confirmPassword.isDirty && !fields.confirmPassword.isValid
                            ? fields.confirmPassword.errorText
                            : ""
                        }}
                      </p>
                      <div class="form-label-group">
                        <input
                          type="text"
                          id="billPayUserId"
                          class="form-control"
                          name="billPayUserId"
                          placeholder="Bill Pay User Id"
                          :disabled="!isLoaded"
                          :value="fields.billpayUserName.value"
                          @input="_updateFieldValue('billpayUserName', $event.target.value)"
                          @blur="_markAsDirty('billpayUserName')"
                        />
                        <label for="billPayUserId">Bill Pay User Id</label>
                      </div>
                      <p class="inputError">
                        {{
                          fields.billpayUserName.isDirty && !fields.billpayUserName.isValid
                            ? fields.billpayUserName.errorText
                            : ""
                        }}
                      </p>
                      <div class="form-group row">
                        <div class="col-12">
                          <fieldset class="checkbox">
                            <div class="vs-checkbox-con vs-checkbox-primary">
                              <input type="checkbox" checked />
                              <span class="vs-checkbox">
                                <span class="vs-checkbox--check">
                                  <i class="vs-icon feather icon-check"></i>
                                </span>
                              </span>
                              <span class=""> I accept the terms & conditions.</span>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <a
                        href="#"
                        @click="$router.push('/login')"
                        class="btn btn-outline-primary float-left btn-inline mb-50"
                        >Login</a
                      >
                      <button
                        type="submit"
                        class="btn btn-primary float-right btn-inline mb-50"
                        @click="_submitRegistrationForm"
                      >
                        Register
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  /* eslint-disable */
import EmailVerificationAlert from "../../../../utils/email-verify-alert";
import Alert from "../../../../utils/general-alert";
import { ApiCalls } from "../../../../api-calls";

export default {
  name: "RegisterPage",

  components: {},

  data() {
    return {
      dialog: false,
      fields: {
        email: {
          value: "",
          isDirty: false,
          isValid: false
        },
        password: {
          value: "",
          isDirty: false,
          isValid: false,
          errorText: ""
        },
        confirmPassword: {
          value: "",
          isDirty: false,
          isValid: false,
          errorText: ""
        },
        billpayUserName: {
          value: "",
          isDirty: false,
          isValid: false,
          errorText: ""
        }
      },
      isFormValid: false,
      snackbar: false,
      notification: false,
      generalError: {
        isVisible: false,
        errorText: ""
      },
      isLoaded: false
    };
  },
  computed: {},
  created() {
    setTimeout(() => {
      this.isLoaded = true
    }, 500);
  },
  methods: {
    async setUserAndRedirectToDashboard(email) {
      localStorage.setItem("username", email);
      this.$router.push("/pages/senders");
      this.dialog = false;
    },
    _markAsDirty(fieldName) {
      this.fields[fieldName].isDirty = true;
    },
    _updateFieldValue(fieldName, value) {
      this.fields[fieldName].value = value;
      this._validateForm();
    },
    _validateForm() {
      let isFormValid = true;
      Object.keys(this.fields).forEach(fieldName => {
        this.fields[fieldName].isValid = true;
        // Default case is not required
        // eslint-disable-next-line default-case
        switch (fieldName) {
          case "email": {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!emailRegex.test(String(this.fields[fieldName].value).toLowerCase())) {
              this.fields[fieldName].isValid = false;
              isFormValid = false;
            }
            break;
          }
          case "password": {
            if (!this.fields[fieldName].value || this.fields[fieldName].value.length === 0) {
              this.fields[fieldName].isValid = false;
              this.fields[fieldName].errorText = "Please set a password";
              isFormValid = false;
            } else if (this.fields[fieldName].value && this.fields[fieldName].value.length < 6) {
              this.fields[fieldName].isValid = false;
              this.fields[fieldName].errorText = "Minimum length should be 6";
              isFormValid = false;
            }
            break;
          }
          case "confirmPassword": {
            if (this.fields.password.value && this.fields.password.value.length) {
              if (!this.fields[fieldName].value || this.fields[fieldName].value.length === 0) {
                this.fields[fieldName].isValid = false;
                this.fields[fieldName].errorText = "Please confirm your password";
                isFormValid = false;
              } else if (
                this.fields[fieldName].value &&
                this.fields[fieldName].value !== this.fields.password.value
              ) {
                this.fields[fieldName].isValid = false;
                this.fields[fieldName].errorText = "Password didn't match";
                isFormValid = false;
              }
            }
            break;
          }
          case "billpayUserName": {
            if (!this.fields[fieldName].value || this.fields[fieldName].value.length === 0) {
              this.fields[fieldName].isValid = false;
              this.fields[fieldName].errorText = "Cannot be empty";
              isFormValid = false;
            } else if (this.fields[fieldName].value && this.fields[fieldName].value.length <= 3) {
              this.fields[fieldName].isValid = false;
              this.fields[fieldName].errorText = "Please enter a valid bill pay user id";
              isFormValid = false;
            }
            break;
          }
        }
      });
      this.isFormValid = isFormValid;
    },
    _makeAllFieldDirty() {
      Object.keys(this.fields).forEach(fieldName => {
        this.fields[fieldName].isDirty = true;
      });
    },
    async _getBillPayUserId(billpayUserName) {
      let billpayUserId = null;
      try {
        const response = await ApiCalls.getBillpayUserIdFromUsername(billpayUserName);
        // console.log("response :>> ", response);
        if (response.status.toString().indexOf('20') > -1) {
          if (response.data && response.data.length && response.data[0].Id) {
            billpayUserId = response.data[0].Id;
          }
        }
      // eslint-disable-next-line no-empty
      } catch (error) {}
      return billpayUserId;
    },
    async _submitRegistrationForm(e) {
      this.generalError = {
        isVisible: false,
        errorText: ""
      };
      e.preventDefault();
      this._makeAllFieldDirty();
      this._validateForm();
      if (this.isFormValid) {
        this.dialog = true;
        const email = this.fields.email.value;
        const password = this.fields.password.value;
        const billpayUserName = this.fields.billpayUserName.value;
        // First validate bill pay user id
        const billPayUserId = await this._getBillPayUserId(billpayUserName);
        if (billPayUserId) {
          try {
            // await FirebaseAuthService.register(email, password, billPayUserId);
            // EmailVerificationAlert.show(email, {
            //   shouldShowResendAction: false
            // });
            localStorage.clear();
            this.dialog = false;
            // this.$router.push("/admin/dashboard");
          } catch (error) {
            // console.log('error :>> ', error);
            this.dialog = false;
            this.notification = error.message;
            this.snackbar = true;
          }
        } else {
          // Invalid bill pay user id
          this.dialog = false;
          this.fields.billpayUserId.value = '';
          this.fields.billpayUserId.isDirty = true;
          this.fields.billpayUserId.isValid = false;
          this.fields.billpayUserId.errorText = 'Please enter a valid bill pay user id';
          Alert.show({
            icon: "error",
            title: "Invalid Bill Pay User Id",
            text: "Please enter a valid bill pay user id to proceed"
          });
        }
      }
    }
  }
};
</script>

<style>
@import url("./register-page.scss");
</style>
